(() => {
  'use strict';
  const apiRoot = window.Shopify?.routes?.root || '/';
  function init(root) {
    if (root.dataset.cartInitialized) return;
    root.dataset.cartInitialized = 'true';
    const form = root.querySelector('[data-bcart-form]');
    if (!form) return;
    const note = root.querySelector('[data-bcart-note]');
    const error = root.querySelector('[data-bcart-error]');
    let busy = false, noteTimer, submitting = false;
    let savedNote = note?.value || '';
    let noteRequest = Promise.resolve();
    const disabledBefore = new Map();
    function message(text) {
      if (!error) return;
      error.textContent = text || '';
      error.hidden = !text;
    }
    function setBusy(value) {
      busy = value;
      root.setAttribute('aria-busy', String(value));
      const controls = [...root.querySelectorAll('button,input'), ...document.querySelectorAll('[form="' + form.id + '"]')];
      controls.forEach(control => {
        if (value) {
          if (!disabledBefore.has(control)) disabledBefore.set(control, control.disabled);
          control.disabled = true;
        } else if (disabledBefore.has(control)) {
          control.disabled = disabledBefore.get(control);
          disabledBefore.delete(control);
        }
      });
      root.querySelectorAll('.bcart__express').forEach(element => { element.inert = value; });
    }
    async function request(path, body) {
      const response = await fetch(apiRoot + path, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) {
        const failure = new Error(typeof result.description === 'string' ? result.description : root.dataset.cartError);
        failure.cartMessage = true;
        throw failure;
      }
      return result;
    }
    function flushNote() {
      clearTimeout(noteTimer);
      noteRequest = noteRequest.catch(() => {}).then(async () => {
        if (!note || note.value === savedNote) return;
        const value = note.value;
        await request('cart/update.js', { note: value });
        savedNote = value;
      });
      return noteRequest;
    }
    window.theme.flushCartNote = flushNote;
    note?.addEventListener('input', () => {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(() => flushNote().catch(() => message(root.dataset.cartError)), 600);
    });
    async function mutate(path, data) {
      if (busy || window.theme.cartMutationPending) return;
      window.theme.cartMutationPending = true;
      setBusy(true);
      message('');
      try {
        await flushNote();
        await request(path, data);
        window.location.reload();
      } catch (failure) {
        root.querySelectorAll('[data-bcart-qty]').forEach(input => { input.value = input.defaultValue; });
        message(failure.cartMessage ? failure.message : root.dataset.cartError);
        error?.focus();
        window.theme.cartMutationPending = false;
        setBusy(false);
      }
    }
    root.addEventListener('click', event => {
      const button = event.target.closest?.('[data-bcart-inc],[data-bcart-dec],[data-bcart-remove],[data-bcart-add]');
      if (!button) return;
      event.preventDefault();
      if (button.hasAttribute('data-bcart-add')) {
        mutate('cart/add.js', { id: Number(button.dataset.bcartAdd), quantity: 1 });
        return;
      }
      const key = button.dataset.bcartInc || button.dataset.bcartDec || button.dataset.bcartRemove;
      const input = Array.from(root.querySelectorAll('[data-bcart-qty]')).find(item => item.dataset.bcartQty === key);
      if (!input) return;
      let quantity = Number(input.value);
      if (!Number.isInteger(quantity) || quantity < 0) quantity = Number(input.defaultValue);
      quantity = button.hasAttribute('data-bcart-remove') ? 0 : button.hasAttribute('data-bcart-inc') ? quantity + 1 : Math.max(0, quantity - 1);
      mutate('cart/change.js', { id: key, quantity });
    });
    root.addEventListener('change', event => {
      const input = event.target.closest?.('[data-bcart-qty]');
      if (!input) return;
      const quantity = Number(input.value);
      if (!input.value.trim() || !Number.isInteger(quantity) || quantity < 0) {
        input.value = input.defaultValue;
        message(root.dataset.quantityError);
        return;
      }
      if (busy || window.theme.cartMutationPending) { input.value = input.defaultValue; return; }
      mutate('cart/change.js', { id: input.dataset.bcartQty, quantity });
    });
    form.addEventListener('submit', async event => {
      if (submitting) return;
      event.preventDefault();
      if (busy || window.theme.cartMutationPending) return;
      const submitter = event.submitter;
      setBusy(true);
      try {
        await flushNote();
        setBusy(false);
        submitting = true;
        form.requestSubmit(submitter || undefined);
      } catch (_) {
        setBusy(false);
        message(root.dataset.cartError);
        error?.focus();
      }
    });
    document.addEventListener('beocca:cart-busy', event => setBusy(event.detail.busy));
  }
  const initAll = () => document.querySelectorAll('[data-bcart-root]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
